import { QueryParams } from '@ngrx/data';
import { isNil } from 'lodash';
import { SortEvent } from 'mbs-ui-kit';

export interface QueryParamsApi {
  [name: string]: string | string[];
  search?: string;
  take?: string;
  offset?: string;
  orderBy?: string;
}

export class QueryParamsBuilder {
  private queryParamsApi: QueryParamsApi = {};

  /*
   * Append some key-value pair
   *
   * `?key=value`
   *
   * @param key query key
   * @param value query value
   */
  public add(key: string, value: string): QueryParamsBuilder {
    this.queryParamsApi[key] = value;
    return this;
  }

  /*
   * Append `search` parameter some term
   *
   * `?search=value`
   * @param value query value
   */
  public addSearch(value: string): QueryParamsBuilder {
    this.queryParamsApi.search = value;
    return this;
  }

  /*
   * Append `take` parameter to get the required number of records
   *
   * `?take=value`
   * @param value query value
   */
  public addTake(value: number | string): QueryParamsBuilder {
    this.queryParamsApi.take = String(value);
    return this;
  }

  /*
   * Append `offset` parameter to get records with offset
   *
   * `?offset=value`
   * @param value query value
   */
  public addOffset(value: number | string): QueryParamsBuilder {
    this.queryParamsApi.offset = String(value);
    return this;
  }

  /*
   * Append `offset` and `take` parameters to get with pagination
   *
   * `?take=value&offset=value`
   * @param value query value
   */
  public addPagination(page: number, pageSize: number): QueryParamsBuilder {
    this.queryParamsApi.take = pageSize.toString();
    this.queryParamsApi.offset = (page * pageSize).toString();
    return this;
  }

  /*
   * Append `orderBy` parameter for sorting
   *
   * `?orderBy=columnName:ASC`
   * @param sortOptions
   */
  public addSort(sortOptions: SortEvent): QueryParamsBuilder {
    this.queryParamsApi.orderBy = `${sortOptions.column}:${sortOptions.direction}`;
    return this;
  }

  /*
   * Build and return `QueryParams`
   */
  public build(): QueryParams {
    return this.queryParamsApi as QueryParams;
  }
}

export function prepareParamsByPayload(payload: { [key: string]: any }): { [key: string]: any } {
  const params: { [key: string]: any } = {};

  for (const key in payload) {
    if (!isNil(payload[key])) {
      params[key] = payload[key];
    }
  }

  return params;
}
